import { FC, useMemo } from 'react';
import { Button, ButtonContentWithLoader, ButtonVariant } from '@edikk-edikk/country-layout-black';
import { SvgIcon } from '@edikk-edikk/svg-icon';
import { Heart } from '@edikk-edikk/icon/Heart';
import { useFavoriteToggleContext, useFavoriteToggleHandlerClick } from '#baseMenu/components';
import { useAdvertFavoriteVisibleControl } from '#advertFavorite/hooks';
import { useMenuState } from '#baseMenu/hooks';

const FavoriteToggleButton: FC = () => {
  const { isOpen } = useAdvertFavoriteVisibleControl();
  const { isLoadInProcess } = useFavoriteToggleContext();
  const { isActionsBlocked } = useMenuState();
  const handlerClick = useFavoriteToggleHandlerClick();
  const ariaLabel = useMemo(() => (isOpen ? 'Close favorite' : 'Open favorite'), [isOpen]);

  return (
    <Button
      variant={isOpen ? ButtonVariant.white65 : ButtonVariant.black65}
      circle
      onClick={handlerClick}
      aria-label={ariaLabel}
      pointerEventsNone={isActionsBlocked}
    >
      <ButtonContentWithLoader
        isLoading={isLoadInProcess}
        content={<SvgIcon Component={Heart} width={20} height={20} isWithoutFill isNeedWrap={false} />}
      />
    </Button>
  );
};

export { FavoriteToggleButton };
